export const USER_FEATURE_KEY = 'user';
